var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-1", attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "" } },
            [
              !_vm.foldersDrawer
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.foldersDrawer = true
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-folder-multiple"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        49323421
                      ),
                    },
                    [_c("span", [_vm._v("Open folders")])]
                  )
                : _vm._e(),
              _c("v-breadcrumbs", {
                attrs: { large: "", items: _vm.pathItems },
                scopedSlots: _vm._u([
                  {
                    key: "divider",
                    fn: function () {
                      return [_c("v-icon", [_vm._v("mdi-chevron-right")])]
                    },
                    proxy: true,
                  },
                  {
                    key: "item",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-breadcrumbs-item",
                          [
                            item !== "root"
                              ? _c("FeathersVuexGet", {
                                  attrs: { service: "directories", id: item },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var folder = ref.item
                                          return [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "folder-name",
                                                attrs: {
                                                  to: {
                                                    name: "Folders",
                                                    params: { folderId: item },
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      folder
                                                        ? folder.name
                                                        : item
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _c(
                                  "span",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "folder-name",
                                        attrs: { to: { name: "Folders" } },
                                      },
                                      [_vm._v(" Home ")]
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("v-spacer"),
              _c(
                "v-scale-transition",
                { attrs: { origin: "center right" } },
                [
                  _c(
                    "v-card",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.selectedItem !== null &&
                            _vm.selectedItem._type === "case",
                          expression:
                            "selectedItem !== null && selectedItem._type === 'case'",
                        },
                      ],
                      attrs: { flat: "" },
                    },
                    [
                      _c("DialogForm", {
                        attrs: {
                          title:
                            "Move to " +
                            (_vm.moveDestination.name || "folder..."),
                          icon: "mdi-folder-move-outline",
                          tooltip: "Move to...",
                          submit: _vm.moveItems(),
                          disabled: _vm.selectedItem && _vm.selectedItem.locked,
                          dialog: _vm.moveCaseDialog,
                          "max-width": 0,
                          "dialog-props": { width: "unset" },
                        },
                        on: {
                          "update:dialog": function ($event) {
                            _vm.moveCaseDialog = $event
                          },
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                          open: _vm.setMoveToValue,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _c("FolderTreeSelect", {
                                  model: {
                                    value: _vm.moveDestination,
                                    callback: function ($$v) {
                                      _vm.moveDestination = $$v
                                    },
                                    expression: "moveDestination",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _vm.selectedItem && !_vm.selectedMultiple
                        ? _c("DialogForm", {
                            attrs: {
                              title: "Edit Case",
                              icon: "mdi-pencil-outline",
                              submit: _vm.updateCase(_vm.selectedItem),
                              disabled:
                                _vm.selectedItem && _vm.selectedItem.locked,
                              tooltip: "Rename case",
                              dialog: _vm.editCaseDialog,
                            },
                            on: {
                              "update:dialog": function ($event) {
                                _vm.editCaseDialog = $event
                              },
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Name",
                                          counter: "64",
                                          rules: [
                                            _vm.$utils.validation.required,
                                            _vm.$utils.validation.counter(64),
                                          ],
                                          maxlength: "64",
                                        },
                                        model: {
                                          value: _vm.selectedItem.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "selectedItem.name",
                                        },
                                      }),
                                      _c("v-textarea", {
                                        attrs: { filled: "", label: "Notes" },
                                        model: {
                                          value: _vm.selectedItem.notes,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedItem,
                                              "notes",
                                              $$v
                                            )
                                          },
                                          expression: "selectedItem.notes",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2133903921
                            ),
                          })
                        : _vm._e(),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var onTooltip = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: {
                                          icon: "",
                                          disabled:
                                            _vm.selectedItem &&
                                            _vm.selectedItem.locked,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.duplicateItems.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      onTooltip
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          "mdi-file-document-multiple-outline"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedMultiple
                                  ? "Duplicate"
                                  : "Duplicate case"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm.selectedItem && !_vm.selectedMultiple
                        ? _c("DialogForm", {
                            attrs: {
                              title: "Copy Case",
                              icon: "mdi-content-copy",
                              disabled:
                                _vm.selectedItem && _vm.selectedItem.locked,
                              tooltip: "Remodel case",
                              maxWidth: "600",
                              submit: _vm.remodelCase(_vm.selectedItem.id),
                              dialog: _vm.remodelCaseDialog,
                            },
                            on: {
                              "update:dialog": function ($event) {
                                _vm.remodelCaseDialog = $event
                              },
                              open: function ($event) {
                                return _vm.fillCopyForm(_vm.selectedItem)
                              },
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Case Name",
                                          counter: "64",
                                          rules: [
                                            _vm.$utils.validation.required,
                                            _vm.$utils.validation.counter(64),
                                          ],
                                          maxlength: "64",
                                        },
                                        model: {
                                          value: _vm.copyForm.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.copyForm, "name", $$v)
                                          },
                                          expression: "copyForm.name",
                                        },
                                      }),
                                      _c("v-switch", {
                                        attrs: {
                                          label: "Disable Storage Expansion",
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.copyForm.disableStorage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.copyForm,
                                              "disableStorage",
                                              $$v
                                            )
                                          },
                                          expression: "copyForm.disableStorage",
                                        },
                                      }),
                                      _c("v-switch", {
                                        attrs: {
                                          label:
                                            "Create Delta against original case",
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.copyForm.createDelta,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.copyForm,
                                              "createDelta",
                                              $$v
                                            )
                                          },
                                          expression: "copyForm.createDelta",
                                        },
                                      }),
                                      _vm.copyForm.createDelta
                                        ? _c("v-text-field", {
                                            staticClass: "pl-6 pr-4",
                                            attrs: {
                                              rules: [
                                                _vm.$utils.validation.required,
                                              ],
                                              label: "Delta Name",
                                            },
                                            model: {
                                              value: _vm.copyForm.deltaName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.copyForm,
                                                  "deltaName",
                                                  $$v
                                                )
                                              },
                                              expression: "copyForm.deltaName",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-switch", {
                                        attrs: {
                                          label: "Keep previous results",
                                          hint: "Keep Alternative Analysis and Production Cost results when updating case",
                                          "persistent-hint": "",
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.copyForm.keepResults,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.copyForm,
                                              "keepResults",
                                              $$v
                                            )
                                          },
                                          expression: "copyForm.keepResults",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2903489538
                            ),
                          })
                        : _vm._e(),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var onTooltip = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openInNewMultiple.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      onTooltip
                                    ),
                                    [_c("v-icon", [_vm._v("mdi-open-in-new")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Open in new tab")])]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var onTooltip = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: {
                                          icon: "",
                                          disabled:
                                            _vm.selectedItem &&
                                            _vm.selectedItem.locked,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteItems.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      onTooltip
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-trash-can-outline"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Delete")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("v-text-field", {
                    staticClass: "pt-6 mx-2",
                    attrs: {
                      filled: "",
                      rounded: "",
                      placeholder: "Search",
                      "prepend-inner-icon": "mdi-magnify",
                      dense: "",
                    },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                ],
                1
              ),
              _c("DialogForm", {
                attrs: {
                  title: "Create new case",
                  "max-width": "600px",
                  submit: _vm.addCase(_vm.newCaseName),
                  dialog: _vm.newCaseDialog,
                },
                on: {
                  "update:dialog": function ($event) {
                    _vm.newCaseDialog = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function (ref) {
                      var onDialog = ref.on
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var onTooltip = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "my-0",
                                            attrs: { icon: "", large: "" },
                                          },
                                          onDialog
                                        ),
                                        [
                                          _c("v-icon", _vm._g({}, onTooltip), [
                                            _vm._v("mdi-file-plus-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Create case")])]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c("v-text-field", {
                          attrs: {
                            label: "Name",
                            placeholder: "New Case",
                            counter: "64",
                            rules: [
                              _vm.$utils.validation.required,
                              _vm.$utils.validation.counter(64),
                              _vm.$utils.validation.specialCharacters,
                            ],
                            maxlength: "64",
                          },
                          model: {
                            value: _vm.newCaseName,
                            callback: function ($$v) {
                              _vm.newCaseName = $$v
                            },
                            expression: "newCaseName",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("DialogForm", {
                attrs: {
                  title: "Create new folder",
                  "max-width": "600px",
                  submit: _vm.createFolder(_vm.newFolderName),
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function (ref) {
                      var onDialog = ref.on
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var onTooltip = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "my-0",
                                            attrs: { icon: "", large: "" },
                                          },
                                          onDialog
                                        ),
                                        [
                                          _c("v-icon", _vm._g({}, onTooltip), [
                                            _vm._v("mdi-folder-plus-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Create folder")])]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c("v-text-field", {
                          attrs: {
                            label: "Name",
                            placeholder: "New Folder",
                            counter: "64",
                            rules: [
                              _vm.$utils.validation.required,
                              _vm.$utils.validation.counter(64),
                              _vm.$utils.validation.specialCharacters,
                            ],
                            maxlength: "64",
                          },
                          model: {
                            value: _vm.newFolderName,
                            callback: function ($$v) {
                              _vm.newFolderName = $$v
                            },
                            expression: "newFolderName",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "v-card",
                {
                  staticClass: "ml-2",
                  attrs: { height: "60", flat: "", "max-width": "160" },
                },
                [
                  _c("v-select", {
                    staticClass: "pt-4",
                    attrs: {
                      label: "Sort by",
                      items: _vm.sortItems,
                      dense: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.sortBy,
                      callback: function ($$v) {
                        _vm.sortBy = $$v
                      },
                      expression: "sortBy",
                    },
                  }),
                ],
                1
              ),
              _vm.selectedItem && _vm.selectedItem._type === "folder"
                ? _c("DialogForm", {
                    attrs: {
                      title: "Rename Folder",
                      dialog: _vm.editFolderDialog,
                      submit: _vm.updateFolder(_vm.selectedItem),
                      "no-activator": "",
                    },
                    on: {
                      "update:dialog": function ($event) {
                        _vm.editFolderDialog = $event
                      },
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Name",
                                  counter: "64",
                                  rules: [
                                    _vm.$utils.validation.required,
                                    _vm.$utils.validation.counter(64),
                                  ],
                                  maxlength: "64",
                                },
                                model: {
                                  value: _vm.selectedItem.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectedItem, "name", $$v)
                                  },
                                  expression: "selectedItem.name",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      114265417
                    ),
                  })
                : _vm._e(),
              _vm.selectedItem && _vm.selectedItem._type === "folder"
                ? _c("DialogForm", {
                    attrs: {
                      title:
                        "Move to " + (_vm.moveDestination.name || "folder..."),
                      dialog: _vm.moveFolderDialog,
                      submit: _vm.moveFolder(_vm.selectedItem),
                      "no-activator": "",
                      "max-width": 0,
                      "dialog-props": { width: "unset" },
                    },
                    on: {
                      "update:dialog": function ($event) {
                        _vm.moveFolderDialog = $event
                      },
                      open: _vm.setMoveToValue,
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("FolderTreeSelect", {
                                model: {
                                  value: _vm.moveDestination,
                                  callback: function ($$v) {
                                    _vm.moveDestination = $$v
                                  },
                                  expression: "moveDestination",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      590886332
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            [
              _c("FolderTree", {
                ref: "FolderTree",
                attrs: {
                  items: _vm.computedTableItems,
                  calculations: _vm.calculations,
                  search: _vm.searchText,
                  selected: _vm.selectedItems,
                  "sort-by": _vm.sortBy,
                },
                on: {
                  "update:search": function ($event) {
                    _vm.searchText = $event
                  },
                  "update:selected": function ($event) {
                    _vm.selectedItems = $event
                  },
                  "case-menu-click": _vm.caseMenuClick,
                  "folder-menu-click": _vm.folderMenuClick,
                },
              }),
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              attrs: { timeout: 2000 },
              scopedSlots: _vm._u([
                {
                  key: "action",
                  fn: function (ref) {
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            attrs: { color: "primary", text: "" },
                            on: {
                              click: function ($event) {
                                _vm.snackbar.state = false
                              },
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [_vm._v(" Close ")]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.snackbar.state,
                callback: function ($$v) {
                  _vm.$set(_vm.snackbar, "state", $$v)
                },
                expression: "snackbar.state",
              },
            },
            [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }